<template>
  <div class="newsAndInformation">
    <div class="title">
      <span>新闻资讯</span>
      <span>NEWS AND INFORMATION</span>
    </div>
    <div class="newsList">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="最新" name="0">
          <ul>
            <li
              class="liBox"
              @click="goNewsDetail(item.id)"
              v-for="item in newsList"
              :key="item.id"
            >
              <div>{{ item.typeName }}</div>
              <div>
                <p>{{ item.newsTitle }}</p>
                <p>
                  {{ item.newsTags }}
                </p>
              </div>
              <!-- <div>查看详情<i class="el-icon-arrow-right"></i></div> -->
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="行业资讯" name="1"
          ><ul>
            <li
              class="liBox"
              @click="goNewsDetail(item.id)"
              v-for="item in newsList"
              :key="item.id"
            >
              <div>{{ item.typeName }}</div>
              <div>
                <p>{{ item.newsTitle }}</p>
                <p>
                  {{ item.newsTags }}
                </p>
              </div>
              <!-- <div>查看详情<i class="el-icon-arrow-right"></i></div> -->
            </li>
          </ul></el-tab-pane
        >
        <el-tab-pane label="热点新闻" name="2"
          ><ul>
            <li
              class="liBox"
              @click="goNewsDetail(item.id)"
              v-for="item in newsList"
              :key="item.id"
            >
              <div>{{ item.typeName }}</div>
              <div>
                <p>{{ item.newsTitle }}</p>
                <p>
                  {{ item.newsTags }}
                </p>
              </div>
              <!-- <div>查看详情<i class="el-icon-arrow-right"></i></div> -->
            </li>
          </ul></el-tab-pane
        >
        <el-tab-pane label="公司动态" name="3"
          ><ul>
            <li
              class="liBox"
              @click="goNewsDetail(item.id)"
              v-for="item in newsList"
              :key="item.id"
            >
              <div>{{ item.typeName }}</div>
              <div>
                <p>{{ item.newsTitle }}</p>
                <p>
                  {{ item.newsTags }}
                </p>
              </div>
              <!-- <div>查看详情<i class="el-icon-arrow-right"></i></div> -->
            </li>
          </ul></el-tab-pane
        >
        <el-tab-pane label="政策法规" name="4"
          ><ul>
            <li
              class="liBox"
              @click="goNewsDetail(item.id)"
              v-for="item in newsList"
              :key="item.id"
            >
              <div>{{ item.typeName }}</div>
              <div>
                <p>{{ item.newsTitle }}</p>
                <p>
                  {{ item.newsTags }}
                </p>
              </div>
              <!-- <div>查看详情<i class="el-icon-arrow-right"></i></div> -->
            </li>
          </ul></el-tab-pane
        >
      </el-tabs>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="requestParameters.pageSize"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getNewsList } from "@/api/news";
export default {
  name: "NewsAndInformation",
  data() {
    return {
      newsList: [],
      activeName: "0",
      industryInformationList: [], //行业资讯
      hotNewsList: [], //热点新闻
      companyDynamicsList: [], //公司动态
      policiesAndRegulationsList: [], //政策法规
      total: 1,
      requestParameters: {
        pageNum: 1,
        pageSize: 5,
        newsType: null,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getNewsList(this.requestParameters);
    },
    getNewsList(data) {
      getNewsList(data).then((res) => {
        this.newsList = res.data.records;
        this.total = JSON.parse(res.data.total);
        this.newsList.forEach((item) => {
          let type = item.newsType;
          switch (type) {
            case "0":
              item.typeName = "行业资讯";
              break;
            case "1":
              item.typeName = "热点新闻";
              break;
            case "2":
              item.typeName = "公司动态";
              break;
            case "3":
              item.typeName = "政策法规";
              break;
          }
        });
      });
    },
    handleClick(tab) {
      this.requestParameters.pageNum = 1;
      if (tab.name == 0) {
        this.requestParameters.newsType = null;
      } else {
        this.requestParameters.newsType = tab.name - 1;
      }
      this.getNewsList(this.requestParameters);
    },
    handleCurrentChange(val) {
      this.requestParameters.pageNum = val;
      this.getNewsList(this.requestParameters);
    },
    goNewsDetail(id) {
      this.$router.push({ path: "/NewsDetail", query: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.newsAndInformation {
  width: 100%;
  padding-bottom: 50px;
  // background: #e3e3e3;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title {
  text-align: center;
  padding: 100px 0 30px 0;
  > span:first-child {
    display: block;
    font-size: 32px;
    font-weight: 700;
  }
  > span:nth-child(2) {
    display: inline-block;
    font-size: 12px;
    font-weight: 300;
    padding: 5px 0;
    border-bottom: solid 5px rgb(75, 140, 255);
  }
}
.newsList {
  width: 65%;
  min-height: 650px;
  position: relative;
  /deep/.el-tabs {
    .el-tabs__header {
      margin: 0 0 1px;
      .el-tabs__nav-wrap {
        border: solid 1px #409eff;
        .el-tabs__nav {
          width: 100%;
          .el-tabs__item {
            width: 20%;
            font-size: 20px;
            text-align: center;
          }
        }
      }
    }
    .is-active {
      background: #409eff;
      color: #fff;
    }
  }
  li:hover {
    background: #ebf7ff;
  }
}
.liBox {
  display: flex;
  position: relative;
  justify-content: space-around;
  align-items: center;
  padding: 20px;
  border-bottom: dashed 1px #b4b4b4;
  > div:nth-child(1) {
    width: 55px;
    height: 50px;
    padding: 5px 0 5px 5px;
    // color: #fff;
    // background: #bababa;
    border: #202020 1px solid;
    color: #202020;
    border-radius: 10%;
    text-align: center;
    font-size: 18px;
    letter-spacing: 5px;
    margin-right: 20px;
  }
  > div:nth-child(2) {
    width: 80%;
    > p:nth-child(1) {
      font-size: 18px;
      font-weight: bold;
      color: #202020;
      margin-bottom: 10px;
    }
    > p:nth-child(2) {
      color: #515151;
      font-size: 15px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden; //溢出内容隐藏
      text-overflow: ellipsis; //文本溢出部分用省略号表示
      display: -webkit-box; //特别显示模式
      -webkit-line-clamp: 2; //行数
      line-clamp: 2;
      -webkit-box-orient: vertical; //盒子中内容竖直排列
    }
  }
  // > div:nth-child(3) {
  //   font-size: 15px;
  //   color: #409eff;
  // }
}
.liBox:hover {
  cursor: pointer;
}
/deep/.el-pagination {
  position: absolute;
  bottom: 0;
  right: 0;
}
/deep/.el-tabs__active-bar {
  height: 0px;
}
@media screen and (max-width: 800px) {
  /deep/.newsList {
    width: 90%;
    min-height: 700px;
    .el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav .el-tabs__item {
      font-size: 13px;
    }
    .el-tabs__item {
      padding: 0;
    }
    .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
    .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
    .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding: 0;
    }
    .liBox {
      padding: 20px 0;
      > div:nth-child(1) {
        padding: 5px 0 0 5px;
        font-size: 15px;
        margin-right: 10px;
      }
      > div:nth-child(2) {
        width: 80%;
        > p:nth-child(1) {
          font-size: 15px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden; //溢出内容隐藏
          text-overflow: ellipsis; //文本溢出部分用省略号表示
          display: -webkit-box; //特别显示模式
          -webkit-line-clamp: 1; //行数
          line-clamp: 1;
          -webkit-box-orient: vertical; //盒子中内容竖直排列
        }
      }
      // > div:nth-child(3) {
      //   display: none;
      // }
    }
  }
}
</style>